module.exports = __webpack_public_path__ + "static/media/logoHamina.f747ac5c.png";